import { securedAxiosAPI } from 'utils/axios';

// APIS
import { store } from '../../store';
// Secured Routes

const securedRoute = {
    baseUrl: 'system-log'
};

//
export const getSystemLogList = async (data) => {
    const { paginationFilterName } = data;
    const { getState } = store;
    const { page, rowsPerPage } = getState().lab.paginations[paginationFilterName];
    const res = await securedAxiosAPI.post(`${securedRoute?.baseUrl}`, { ...data, page: page + 1, limit: rowsPerPage });
    return res.data;
};
// update page naviagation
export const addSystemLog = async (data) => {
    const { getState } = store;

    const { loggedInUser } = getState().user;
    const { moduleName, Screen } = data;
    const res = await securedAxiosAPI.post(
        `${securedRoute?.baseUrl}/add`,
        {
            email: loggedInUser?.email,
            userId: loggedInUser?.userID,
            module: moduleName,
            eventType: 'View',
            eventMessage: `user visited ${Screen} `,
            eventStatus: 'SUCCESS',
            eventDetails: ''
        },
        {
            headers: {
                'x-page-url': window.location.href
            }
        }
    );
    return res.data;
};
